import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  History, Loader,
  NoteDrawer,
  SimpleTabs,
} from 'components';
import { loadActions } from 'store';
import { FindLoad, Images, useTertiaryModal } from 'utils';
import { loadsStyle } from '../../../pages/loads/styles';
import { GroupDetails } from './core/groupDetails';
import { GroupTransactions } from './core/groupTransactions';

const ACTION_TYPE = 'GET_GROUP_BY_ID';

export const GroupedLoadDetails = ({ id, afterSuccess }) => {
  const { groupById } = useSelector((state) => ({
    groupById: state.loads.groupById,
  }));
  const classes = loadsStyle();
  // const params = { id: id };
  const dispatch = useDispatch();
  const [tab, setTab] = useState('Details');
  const { closeTertiary } = useTertiaryModal();
  const loader = FindLoad(ACTION_TYPE);

  useEffect(() => {
    dispatch(loadActions.getGroupById(id));
  }, [dispatch]);

  const tabsLabels = [
    {
      label: 'Details',
    },
    {
      label: 'Transactions',
    },
    {
      label: 'History',
    },
  ];

  const tabsContent = [
    {
      tabComponent: <GroupDetails afterSuccess={afterSuccess} />,
      tab: 'Details',
    },
    {
      tabComponent: <GroupTransactions />,
      tab: 'Transactions',
    },
    {
      tabComponent: <History onModel={'loadGroup'} resourceId={groupById?.id} />,
      tab: 'History',
    },
  ];

  return (
    <div className={classes.loadModalWrapper}>
      {loader?.length ?
        <Loader height={'90vh'} />
        :
      <div>
      <div className={classes.loadModalHeader}>
        <p>{groupById?.displayId ? `Load Group/${groupById?.displayId}` : ''} </p>
        <div className="align-center" style={{ gap: 20 }}>
          <button className="reset-btn" onClick={closeTertiary}>
            <img src={Images.closeBtn} alt={'print'} />
          </button>
        </div>
      </div>
      <div>
        <div style={{ height: 95 }} />
        <SimpleTabs
          // headerWidth={'480px'}
          head={
            <div className="space-between" style={{ gap: 15 }}>
              {/*<div className={classes.loadIdWrapper}>*/}
              {/*  <img src={Images.loadFillBlue} alt={'icon'} />*/}
              {/*  <p>{groupById?.displayId} </p>*/}
              {/*</div>*/}
              <NoteDrawer title={'Load'} customParams={{id: groupById?.id}}  />
            </div>
          }
          noBread={true}
          border={'blue'}
          height={'full'}
          tabsLabels={tabsLabels}
          tabsContent={tabsContent}
          // defaultTab={'Details'}
          defaultTab={tab}
          getTab={(tab) => setTab(tab)}
          useDefault={true}
        />
      </div>
      </div>
      }
    </div>
  );
};